
export const GET_CSR_COMPLAINTS = "GET_CSR_COMPLAINTS";
export const GET_CSR_COMPLAINTS_SUCCESS = "GET_CSR_COMPLAINTS_SUCCESS";
export const GET_CSR_COMPLAINTS_FAIL = "GET_CSR_COMPLAINTS_FAIL";

export const UPDATE_CSR_COMPLAINTS = "UPDATE_CSR_COMPLAINTS";
export const UPDATE_CSR_COMPLAINTS_SUCCESS =
  "UPDATE_CSR_COMPLAINTS_SUCCESS";
export const UPDATE_CSR_COMPLAINTS_FAIL = "UPDATE_CSR_COMPLAINTS_FAIL";